import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/waylio/Nav";
import Footer from "@/components/waylio/Footer";
import AnnouncementBar from "@/components/waylio/AnnouncementBar";
import TrackingBar from "@/components/waylio/TrackingBar";
import PrivacyBar from "@/components/waylio/PrivacyBar";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import HowWeWorkPage from "@/pages/HowWeWorkPage";
import ClientStoriesPage from "@/pages/ClientStoriesPage";
import ContactPage from "@/pages/ContactPage";
import ResourcesPage from "@/pages/ResourcesPage";
import QuotePage from "@/pages/QuotePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import { AdminAuthProvider } from "@/lib/adminAuth";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const isHome = pathname === "/";
  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden />
      {!isAdmin && <AnnouncementBar />}
      {!isAdmin && <Nav />}
      <ScrollToTop />
      {!isAdmin && <div className="pt-[100px] md:pt-[116px]" aria-hidden />}
      {!isAdmin && isHome && <TrackingBar />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/how-we-work" element={<HowWeWorkPage />} />
        <Route path="/client-stories" element={<ClientStoriesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/quote" element={<QuotePage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboardPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <PrivacyBar />}
      <Toaster richColors position="bottom-right" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <MotionConfig reducedMotion="always">
        <AdminAuthProvider>
          <Shell />
        </AdminAuthProvider>
      </MotionConfig>
    </BrowserRouter>
  );
}

export default App;
